/* eslint-disable */
// /src/services/storePublicService.js
// 사용자 앱: 공개 읽기 전용 (no realtime)

import { collection, doc, getDoc, getDocs, orderBy, query } from "firebase/firestore";
import { db, storage } from "./firebase";

/** 전체 상품(active만) 가져오기 — displayOrder ASC, createdAt DESC 대용으로 id 정렬 */
export async function fetchActiveProducts() {
    const q = query(collection(db, "store_products"), orderBy("displayOrder", "asc"));
    const snaps = await getDocs(q);
    const all = snaps.docs.map(d => ({ id: d.id, ...d.data() }));
    return all.filter(p => (p.status || "active") === "active");
}

/** 단일 상품 가져오기 */
export async function fetchProductById(pid) {
    const ref = doc(db, "store_products", pid);
    const snap = await getDoc(ref);
    return snap.exists() ? { id: snap.id, ...snap.data() } : null;
}

/** 계좌/공지 설정 (전역) */
export async function fetchStoreSettings() {
    const ref = doc(db, "store_settings", "published");
    const snap = await getDoc(ref);
    return snap.exists() ? snap.data() : null;
}
